export const FAN_PAGE = process.env.NEXT_PUBLIC_FAN_PAGE || 'https://fan.passio.eco'

export const KEY_TOKEN = process.env.NEXT_PUBLIC_KEY_TOKEN || 'eco_customer_data'

export const NEXT_PUBLIC_STORE_API_URL = process.env.NEXT_PUBLIC_STORE_API_URL || 'https://next.kol.eco'

export const API_VERSION = process.env.NEXT_PUBLIC_API_VERSION || 'v2'

export const NEXT_PUBLIC_LDP_API_URL = process.env.NEXT_PUBLIC_LDP_API_URL || 'https://acc.passio.eco'

export const FAN_URL = process.env.NEXT_PUBLIC_FAN_URL || 'https://fan.passio.eco'

export const SITE_RECENT = process.env.NEXT_PUBLIC_KEY_COOKIE_SITE_RECENT || 'dev-site-recent'

export const PASSIO_PAGE_INFO = process.env.NEXT_PUBLIC_KEY_PASSIO_PAGE_INFO || 'https://passio.eco'

export const FAN_FREFIX = process.env.NEXT_PUBLIC_FAN_PREFIX || 'fan'

export const DP_FREFIX = process.env.NEXT_PUBLIC_DP_PREFIX || 'dp'

export const DP_URL = process.env.NEXT_PUBLIC_DP_URL || 'https://dp.passio.eco'

export const PASSIO_MAIN_DOMAIN = process.env.NEXT_PUBLIC_PASSIO_MAIN_DOMAIN || 'passio.eco'

export const DATA_TOAST = process.env.NEXT_PUBLIC_DATA_TOAST || 'data_toast'

export const GATEWAY_API_URL = process.env.NEXT_PUBLIC_GATEWAY_API_URL || 'https://gateway.passio.eco'

export const BUILDER_API_URL = process.env.NEXT_PUBLIC_BUILD_API_URL || 'https://builder-api.passio.eco'

export const DAYS_COOKIES_TRACKING = process.env.NEXT_PUBLIC_DAYS_COOKIES_TRACKING || '7'
export const KEY_AFFILIATE_TRACKING_ID = process.env.NEXT_PUBLIC_KEY_AFFILIATE_TRACKING || 'affiliate_tracking_id'

export const KEY_GATEWAY_TOKEN = process.env.NEXT_PUBLIC_KEY_GATEWAY_TOKEN || 'passio_gw_access_token'